<script>
       
    
    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {string} [title]
     * @property {string} [description]
     * @property {any} sectionID
     * @property {any} selected
     * @property {boolean} [link]
     */
    let {
        title = '',
        description = '',
        sectionID,
        selected,
        link = false
    } = $props();
    
    const dispatch = createEventDispatcher();

    function handleTabClick(e) {
        if (selected) return;
        dispatch('selected', e.target);
    }

</script>

<li>
    <button
        onclick={handleTabClick}
        class="sub-tab-item interactive {selected ? 'selected' : ''}"
        title={description}
        data-sectionid={sectionID}
        aria-current={selected}
        role={link ? 'link' : null}
    >
        {title}
    </button>
</li>

<style>
    /*
        Redesign styling from commit 78112c2e (wip: initial redesign) commented out
        below to restore the previous look without losing the changes.
    */
    .sub-tab-item {
        text-transform:uppercase;
        height:1.5rem;
        font-size:0.9rem;
        font-weight:600;
        margin:0.7rem 1.6rem 0 0;
        border-bottom:2px solid rgba(0,0,0,0);
        background-color: transparent;
        color: #000;
        /* font-size:12px;
        font-weight:700;
        letter-spacing:0.04em;
        border-bottom:2.5px solid rgba(0,0,0,0);
        color: rgba(0, 0, 0, 0.55); */
    }

    /* .sub-tab-item:hover{
        color: #000;
    } */

    .sub-tab-item:hover, .sub-tab-item.selected{
        border-bottom: 2px solid #222;
    }

    /* .sub-tab-item.selected{
        font-weight:800;
        color: #000;
        border-bottom: 2.5px solid #000;
        padding-bottom: 2px;
    } */

    
</style>